import * as React from "react"

const DefaultHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={218.617}
    height={195.738}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 3896 3488"
    {...props}
  >
    <defs>
      <style>{".fil1{fill:#a79ecd}"}</style>
    </defs>
    <g id="Livello_x0020_1">
      <path
        d="M2275 171c-82 42-210 83-390 77-164-6-284-46-362-83 63 151 201 245 376 245 167 0 309-96 376-239zm938 1272 60 61 478-476-63-64-469-476c-17-16-48-44-80-74-41 90-179 431-137 814l212 215zM216 954l-72 72 468 477 72-74 214-222c22-364-113-681-161-781-69 64-120 121-121 122L216 953zm2252-829c-9-2-53-9-63-10-57 234-259 399-506 399-248 0-441-157-500-394-10 2-53 11-63 13-59 14-105 28-144 40l-27 8c-73 22-236 92-298 136-36 25-71 55-104 85 49 100 219 485 159 911h-1v2008c143 17 564 63 987 63 554 0 938-45 1057-62V1222c-41-403 111-757 146-832-35-31-67-59-83-70-54-38-169-96-231-118-52-18-185-51-330-76z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        className="fil1"
        d="m3268 1652-208-207zM2323 9l8-9-8 9zM1519 45c2 1 4 3 7 4-2-1-5-3-7-4z"
      />
      <path
        d="M2467 126c-9-2-53-9-63-10-57 234-259 399-506 399-248 0-441-157-500-394-10 2-53 11-63 13-59 14-105 28-144 40l-27 8c-73 22-236 92-298 136-36 25-71 55-104 85 49 100 219 485 159 911h-1v2008c143 17 564 63 987 63 554 0 938-45 1057-62V1223c-41-403 111-757 146-832-35-31-67-59-83-70-54-38-169-96-231-118-52-18-185-51-330-76zM1381 2397V1059h271v527h527v-527h271v1338h-271v-585h-527v585h-271zm1831-953 60 61 478-476-63-64-469-476c-17-16-48-44-80-74-41 90-179 431-137 814l212 215zM215 955l-72 72 468 477 72-74 214-222c22-364-113-681-161-781-69 64-120 121-121 122L215 954zm2059-783c-82 42-210 83-390 77-164-6-284-46-362-83 63 151 201 245 376 245 167 0 309-96 376-239zM1382 19v-3l23-2c11-2 22-4 34-6l24-4 6 5 16-1c0 5 1 11 1 16 27 20 159 111 401 120 293 10 419-119 424-124l2-2c0-3 0-6 1-9h8l8-9 27 3c197 26 401 75 473 100s194 87 256 131c46 32 187 164 203 179l606 616-628 623-208-207v1966l-42 8c-17 3-411 70-1103 70-519 0-1022-69-1027-70l-39-6V1437l-222 216-629-625 541-549c4-4 133-150 267-245 82-58 259-130 328-151l26-8c55-17 122-38 221-57z"
        style={{
          fill: "#252422",
          fillRule: "nonzero",
        }}
      />
    </g>
  </svg>
);

export default DefaultHome;
